module.exports = __webpack_public_path__ + "img/whatsapp.1f0f1183.svg";